// extracted by mini-css-extract-plugin
export default {"avatar":"User_avatar__8wJXU","name":"User_name__-QUmW","emailOption":"User_emailOption__3YdzM","icon":"User_icon__MX7W8","logout":"User_logout__4m2mj"};